export const ActivityLogObj: Record<string, string> = {
  "": "قام {name} بإنشاء المعاملة.",
  CUSTOMER_CREATE_CONTRACT: "قام {name} بإنشاء المعاملة.",
  PROVIDER_CREATE_CONTRACT: "قام {name} بإنشاء المعاملة.",
  BROKER_CREATE_CONTRACT: "قام {name} بإنشاء المعاملة.",
  CUSTOMER_FUND: "قام {name} بدفع قيمة العميلة.",
  CUSTOMER_REQUEST_PAYMENT_VERIFICATION:
    "قام {name} بالدفع عن طريق التحويل البنكي.",
  ADMIN_VERIFY_PAYMENT: "قام فريق وفّي بالتأكد من صحة التحويل.",
  ADMIN_DENY_PAYMENT: "قام فريق وفّي برفض التحويل.",
  CUSTOMER_DENY_DELIVERY: "قام {name} بتصعيد خلال فترة التوصيل.",
  PROVIDER_ESCALATE_DELIVERY: "قام {name} بتصعيد خلال فترة التوصيل.",
  CUSTOMER_CONFIRM_DELIVERY: "قام {name} بتأكيد التوصيل.",
  ADMIN_CONFIRM_DELIVERY: "قام {name} بتأكيد التوصيل.",
  CUSTOMER_REJECT_ITEM: "قام {name} بتصعيد خلال فترة الفحص.",
  PROVIDER_ESCALATE_ITEM: "قام {name} بتصعيد خلال فترة الفحص.",
  CUSTOMER_ACCEPT_ITEM: "قام {name} بتأكيد الفحص.",
  ADMIN_ACCEPT_ITEM: "قام {name} بتأكيد الفحص.",
  ADMIN_RESOLVE_ESCALATION_RELEASE_PROVIDER: "تم حل المشكلة لصالح البائع.",
  ADMIN_RESOLVE_ESCALATION_REFUND_CUSTOMER: "تم حل المشكلة لصالح المشتري.",
  ADMIN_CLOSE_RELEASE_FUND_TO_PROVIDER: "تم تحويل الأموال إلى البائع",
  ADMIN_COMPLETE_RELEASE_FUND_TO_PROVIDER: "تم تحويل الأموال إلى حساب البائع.",
  ADMIN_CLOSE_REFUND_CUSTOMER: "تم إغلاق التصعيد لصالح المشتري.",
};
